import {lazy} from "react";

export const VoyagePlanningWidthLocalStateLazy = lazy(() => import('./VoyagePlanningWithLocalState'))